export const osnContinueWatchingPlayIconIcon = {
  data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g
clip-path="url(#Continue_watching_play_icon_svg__clip0_23027_23915)"><path d="M14.7519 7.16795L5.5547 1.03647C4.89015
0.59343 4 1.06982 4 1.86852L4 14.1315C4 14.9302 4.89014 15.4066 5.5547 14.9635L14.7519 8.83205C15.3457 8.43623 15.3457
7.56377 14.7519 7.16795Z" fill="white"/></g><defs><clipPath id="Continue_watching_play_icon_svg__clip0_23027_23915">
<rect width="16" height="16" fill="white"/></clipPath></defs></svg>`,
  name: 'continue-watching-play-icon',
};
